export default __webpack_public_path__ + "static/media/step_05.f4fca574.png";